module.exports = __webpack_public_path__ + "img/camera.084a374b.svg";